/**
 * Self-Improving Workflow Demo — fixture store.
 *
 * THROWAWAY DEMO CODE. Holds the demo dataset via the shared
 * `createDemoStore`, so the registry gets a `StoreProvider` (re-seeds on mount)
 * and a one-click `reset`. The resolver reads from here. Delete alongside
 * frontend/src/demo/workflow-recovery.
 */

import { createDemoStore } from '@/demo/core/create-demo-store';
import { buildWorkflowRecoveryDataset } from './fixtures';
import type { WorkflowRecoveryDataset } from './fixtures';

export const workflowRecoveryStore = createDemoStore<WorkflowRecoveryDataset>(
  buildWorkflowRecoveryDataset,
);

export const getWorkflowRecoveryState = (): WorkflowRecoveryDataset =>
  workflowRecoveryStore.getState();
